var map = {
	"./_logo.png": "df90",
	"./_suite_logo.png": "b376",
	"./alchemy_logo.png": "2f68",
	"./autobackups_logo.png": "ea11",
	"./canon_logo.png": "5979",
	"./dashboards_logo.png": "3a33",
	"./fluxity_logo.png": "87fe",
	"./integrations_logo.png": "9a2e",
	"./invalid_logo.png": "df45",
	"./kairos_logo.png": "82f0",
	"./mictlan_logo.png": "dd71",
	"./panoptico_logo.png": "64d6",
	"./suite_logo.png": "7fbe",
	"./synapse_logo.png": "59b6",
	"./va_logo.png": "72a8",
	"./vrf_aware_logo.png": "de0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84c3";